export default __webpack_public_path__ + "static/media/TodaysRitual_empty.41cd4da8.png";